import '../../Assets/Styles/home.css';

import React from "react";
import { useMediaQuery } from 'react-responsive'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {useNavigate} from 'react-router-dom';

import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button'; 
import { TabView, TabPanel } from 'primereact/tabview';


import { AutoComplete } from 'primereact/autocomplete';
import { Dropdown } from 'primereact/dropdown';
import Grid from '@mui/material/Grid';

import jwtDecode from 'jwt-decode';

// Load Actions
import * as AppActions from '../../Store/Actions/App'
import * as LoginActions from '../../Store/Actions/Login';

// Load Componentes
import HeaderView from '../../Components/Layout/Header';
import FaqView from '../../Components/Partner/Faq';
import AlertView from '../../Components/AlertModal';

// Search Views
import ForgotPasswordView from './ForgotPasswordModal';

// Set assets
import edoLogoOnly from '../../Assets/Images/edoLogoOnly.svg'; 
import imageFallback from '../../Assets/Images/imagePlaceholder.jpg'; 
import iconLogged from '../../Assets/Images/iconLogged.png';

import {
	getSlugWithId,
	handleClickScroll,
	validarEmail
} from '../../Components/Utils';

const HomePage = (props) => {
	
// Set var from props
const {
	setDialog,
	setLoginStatus,
	loginStatus,
	currentPartner,
	authenticatePartner
} = props;

// set Use of history for PUSH 
var navigate = useNavigate();
	
const isDesktopOrLaptop = useMediaQuery({
query: '(min-width: 1024px)'
})
const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1023px)' });
const isMobile = useMediaQuery({ query: '(max-width: 767px)' });
	
// loading control
const [loading, setLoading] = React.useState(false);

// Alert control
const [alert, setAlert] = React.useState(false); 
const [alertTitle, setAlertTitle] = React.useState("Informações"); 
const [alertBody, setAlertBody] = React.useState("Conteúdo dinâmico"); 
const [alertAction, setAlertAction] = React.useState(null);

// Blog news 
const [noticias, setNoticias] = React.useState([]);

const [partnerPassword, setPartnerPassword] = React.useState('');
const [partnerEmail, setPartnerEmail] = React.useState('');
const [formValidated, setFormValidated] = React.useState(false);

const [forgotPassword, setForgotPassword] = React.useState(false); 	
const [showPassword, setShowPassword] = React.useState(false);
 
  const handleLogin = () => {
    if (!partnerEmail || !partnerPassword) {
      setAlertTitle("Verifique os campos");
      setAlertBody("Por favor, preencha todos os campos.");
      setAlert(true);
      return;
    }
    if (!validarEmail(partnerEmail)) {
      setAlertTitle("Verifique o e-mail");
      setAlertBody("Por favor, insira um e-mail válido.");
      setAlert(true);
      return;
    }
    if (partnerPassword.length < 6) {
      setAlertTitle("Verifique a senha");
      setAlertBody("A senha deve ter pelo menos 6 caracteres.");
      setAlert(true);
      return;
    }

    setLoading(true);

    authenticatePartner(
      {
        email: partnerEmail,
        password: partnerPassword
      },
      {
        setError: (msg) => {
          setLoading(false);
          setAlertTitle("Ops! Ocorreu um problema!");
          setAlertBody(msg);
          setAlert(true);
        },
        setSuccess: () => {
          setLoading(false);
          navigate('/admin/dashboard');
        }
      }
    );

  };

// Função para buscar posts
React.useEffect(() => {
	
	const buscarPosts = async () => {
		try {

			const catRes = await fetch('https://backendcms.estacaodoolho.com.br/wp-json/wp/v2/categories?slug=midia');
			const catData = await catRes.json();
			const catId = catData[0]?.id;
  
			let url = `https://backendcms.estacaodoolho.com.br/wp-json/wp/v2/posts?_embed&per_page=4&categories_exclude=${catId}&orderby=date&order=desc`;

			const res = await fetch(url);
			const data = await res.json();
			setNoticias(data);
		} catch (err) {
			console.error('Erro ao buscar posts:', err);
		}
	};
	buscarPosts();

	window.scrollTo({ top: 0, behavior: 'smooth' });
}, []);


// Função para lidar com o clique na postagem
const handleClick = (noticia) => {
	const url = getSlugWithId(noticia.title?.rendered, noticia.id);
	navigate(url);
};

  /* Load form data */
  React.useEffect(() => {

	if (partnerEmail && partnerPassword) {
	// Validate form
		setFormValidated(
			partnerEmail.trim() !== '' &&
			partnerPassword.trim() !== '' &&
			validarEmail(partnerEmail) &&
			partnerPassword.length >= 6
		);
	} else {
		setFormValidated(false);
	}

  }, [partnerEmail, partnerPassword]);


// If not logged, show login screen
  return (
	<>
	<div id="homeMainSection" className={isMobile ? "wrapper_home__content" : "wrapper_home__content"} >

		<div className="wrapper_home__content_bgPhoto blockBackground" style={{backgroundColor:"#4D4792",height: isMobile ? "76rem" : ""}}></div>

		<HeaderView />

		<div className={isMobile ? "mobileWrapperBox wrapper_home__content_container flex-row justify-center align-items-start" : "wrapper_home__content_container"} style={{paddingTop:"1.5rem",gap:"2rem",display:"flex",flexDirection:isMobile ? "column" : "row",alignItems:"flex-start",justifyContent:"center"}}> 
		

			{/*<!-- Webdoor Slogan and descriptiob + CTA -->*/}
			<div id="searchBox" className="wrapper_home__content_container_block" style={{height:isMobile ? "unset" : "22rem"}}>  

				
				<div className="wrapper_home__content_container_webdoor">

					<div className="w100 tAlignL"><img src={edoLogoOnly} style={{width:"2.5rem",height:"auto",aspectRatio:"40/27.20"}} className="noSelect" /></div>
					<div className="wrapper_home__content_container_webdoor_title">Mais pacientes, menos burocracia.</div>	
					<div className="wrapper_home__content_container_webdoor_description">A Estação do Olho conecta você a pacientes qualificados, sem custos fixos ou dependência de convênios. Amplie sua agenda com eficiência e previsibilidade!</div>
					<div className="wrapper_partner__content_container_webdoor_cta">

						{!loginStatus &&
						<>
							<Button label="Seja Parceiro" className="ctaWebdoor " onClick={() => navigate("/parceiros")} />
						</>
						}

						{(isMobile && !loginStatus) && (
							<Button style={{marginLeft:"1rem"}} label="Faça o login" className="ctaWebdoor outlined" onClick={() => handleClickScroll("loginSection")} />
						)}

						{(isMobile && loginStatus) && (
							<Button style={{marginLeft:"1rem"}} label="Acessar Painel" className="ctaWebdoor outlined" onClick={() => navigate("/admin/dashboard")} />
						)}

					</div>					
				</div>

			</div>	

			{/*<!-- Service Selector -->*/}
			<div id="loginSection" className="wrapper_home__content_container_block" style={{marginTop:isMobile ? "3rem" : "7rem"}}>  
				
				{!loginStatus &&
				<>
				<div className="wrapper_home__content_container_selector">

					<div className="wrapper_home__content_container_selector_top" style={{height:"unset",padding:"1rem"}}>
						<div className="label tAlignL" style={{fontSize:"1.1rem"}}>Já é um parceiro? Faça o login. <br /><br /> Se for paciente ou cliente, acesse <a href="https://www.estacaodoolho.com.br" target="_blank" className="linkLogin">www.estacaodoolho.com.br</a></div>
						<div className="flex-1_5 tabsWrapper">

						</div>
					</div>	
					<div className="wrapper_home__content_container_selector_bottom flex-column" style={{flexDirection:"column",height:"unset",gap:"unset"}}>

						{/* Conteúdo separado */}
						<div className={isMobile ? "w100 flex-column justify-center align-items-center" : "w100 flex-row justify-center align-items-center"} style={{ gap: '1rem',padding:"1rem" }}>
								<div className="w100">
								<Grid container spacing={0}>
									<Grid item xs={12}>
										<div className={isMobile ? "w100 tAlignL formControl flex-column justify-center items-align-center" : "w100 tAlignL formControl flex-row justify-center items-align-start"} style={{ position: 'relative',gap:"0.5rem",flexDirection:"column",padding:"1rem" }}>
											<div className='w100'>
												<label htmlFor="email" className="serviceSelectorLabel">Email <span className="requiredField">*</span></label>
												<InputText 
													id="email"
													tabIndex={1} 
													value={partnerEmail}
													onChange={(e) => setPartnerEmail(e.target.value)}
													placeholder="Digite o seu e-mail"
													className="w100 "
													diabled={loading}
													type="email"
												/>	
											</div>	
											<div className='w100'>
												<label htmlFor="password" className="serviceSelectorLabel">Senha <span className="requiredField">*</span></label>
												<Password
												id="password"
												tabIndex={2}
												value={partnerPassword}
												onChange={(e) => setPartnerPassword(e.target.value)}
												placeholder="Digite a sua senha"
												className="w100"
												feedback={false}
												toggleMask
												inputStyle={{ width: '100%' }}
												disabled={loading}
												/>
											</div>	
											<div style={{width:isMobile ? "100%":"100%",alignSelf:"flex-end",display:"flex",gap:"0.5rem",flexDirection:"row",alignItems:"center",justifyContent:"flex-end"}}>										
												<Button
													label={loading ? "Autenticando..." : "Entrar"}
													rounded
													disabled={!formValidated || loading}
													className="pT10 searchButton filled"
													style={{ maxWidth: isMobile ? '100%' : '15.4rem',minWidth:"11rem"}}
													loading={loading}
													onClick={()=>handleLogin()}
												/>												
											</div>																															
										</div>
									</Grid>
								</Grid>	
								</div>
						</div>

						<div className={isMobile ? "w100 flex-column justify-center align-items-center" : "w100 flex-row justify-center align-items-center"} style={{ gap: '1rem',paddingLeft:isMobile ? "1rem" : "2rem",paddingRight:isMobile ? "1rem" : "2rem", paddingBottom:isMobile ? "1rem" : "2rem"}}>
								<div className="w100">
								<Grid container spacing={0}>
									<Grid item xs={12}>
										<div className={isMobile ? "w100 tAlignL formControl flex-row justify-center items-align-center" : "w100 tAlignL formControl flex-row justify-center items-align-start"} style={{ position: 'relative',gap:"0.5rem" }}>
											<div className='w100 labelLogin'  >
												Não tem acesso? <br /><a href="javascript:void()" className="link" onClick={()=>navigate("/parceiros")}>Torne-se um parceiro</a>	
											</div>	
											<div className='w100 tAlignR labelLogin'>
												Esqueceu a senha? <br /><a href="javascript:void(0)" className="link" onClick={()=> setForgotPassword(true)}>Recupere a sua senha</a>
											</div>																															
										</div>
									</Grid>
								</Grid>	
								</div>
						</div>						

					</div>

				</div>
				</>
				}
				
				{loginStatus &&
				<>
				<div className="wrapper_home__content_container_selector" style={{height:isMobile ? "34em" : "30rem"}}>

					<div className="wrapper_home__content_container_selector_top" style={{height:"unset",padding:"1rem"}}>
						<div className="label tAlignL" style={{fontSize:"1.1rem"}}></div>
						<div className="flex-1_5 tabsWrapper">

						</div>
					</div>	

					<div className="wrapper_home__content_container_selector_bottom flex-column" style={{flexDirection:"column",height:"unset",gap:"unset",flex:1}}>

						{/* Conteúdo separado */}
						<div className="w100 flex-column justify-center align-items-center" style={{ gap: '1rem',padding:"2rem"}}>
							<img src={iconLogged} style={{width:"3rem",height:"auto",}} className="noSelect" />
							<div style={{fontSize:"2rem",fontFamily:"Graphie", color:"#CCC"}}>Você está logado!</div>
							<div><Button label="Acessar o painel" className="filledButton" onClick={() => navigate("/admin/dashboard")} /></div>
						</div>
				
					</div>

				</div>
				</>
				}

			</div>

		</div>			

		{/*<!-- Blog Highlights BOX -->*/}
		<div className="wrapper_home__content_container"> 
		
			{/*<!-- Blog Highlight with 4 cards -->*/}
			<div className="wrapper_home__content_container_block">  

				<div className="wrapper_home__content_container_highlight" style={{paddingLeft:isMobile ? "1rem" : "",paddingRight:isMobile ? "1rem" : "",marginTop:"7.5rem"}}>

						<div><img src={edoLogoOnly} style={{width:"2.5rem",height:"auto",aspectRatio:"40/27.20"}} className="noSelect" /></div>
						<div className="wrapper_home__content_container_highlight_title">Tudo sobre saúde ocular em um só lugar!</div>
						<div className="wrapper_home__content_container_highlight_description">Leia artigos sobre visão, bem-estar e as melhores práticas para cuidar da sua saúde ocular.</div>

				</div>

				<div className="wrapper_home__content_container_cards wrapper_home__content_container_cardsBlog" style={{flexWrap:"nowrap",marginTop:"3.5rem"}}>

					{noticias.map(post => {
						
						const midia = post._embedded?.['wp:featuredmedia']?.[0];
						const image = midia?.media_details?.sizes?.medium?.source_url
						|| midia?.media_details?.sizes?.thumbnail?.source_url
						|| midia?.source_url;	

						//const category = post._embedded?.['wp:term']?.[0]?.[0]?.name || 'Sem categoria';

						const categories = post._embedded?.['wp:term']?.[0] || [];

						// Função para remover acentos
						const sanitize = (str) => {
						  return str.normalize('NFD').replace(/[\u0300-\u036f]/g, "").replace(/\s+/g, '');
						};						

						return (
							<div key={post.id} className="card cardBlog applyPointer" onClick={() => handleClick(post)}>
							<div className="cardBlog__image">
								<img src={image || imageFallback} className="noSelect" alt={post.title.rendered}   onError={(e) => { 
									e.target.onerror = null; // evita loop infinito
									e.target.src = imageFallback;
								}} />
							</div>
							<div className="cardBlog__category" style={{gap:"0.5rem"}}>

								{categories.slice(0, 3).map((cat, idx) => (
									<span key={idx} className={sanitize(cat.name)}>{cat.name}</span>
								))}	

								{categories.length == 0 && (
									<span className="semCategoria">Sem categoria</span>
								)}

							</div>
							<div className="cardBlog__title" dangerouslySetInnerHTML={{ __html: post.title.rendered }} />
							<div className="cardBlog__description" dangerouslySetInnerHTML={{ __html: post.excerpt.rendered }} />
							</div>
						);
					})}			

					{/*<div className="card cardBlog">
						<div className="cardBlog__image"><img src={blogImage} className="noSelect" /></div>
						<div className="cardBlog__category"><span>Na Mídia</span></div>
						<div className="cardBlog__title">Acidentes oculares em esportes</div>
						<div className="cardBlog__description">Lesões oculares relacionadas ao esporte são comuns e podem levar a perda de visão e até (...)</div>
					</div>


					<div className="card cardBlog">
						<div className="cardBlog__image"><img src={blogImage2} className="noSelect" /></div>
						<div className="cardBlog__category"><span>Na Mídia</span></div>
						<div className="cardBlog__title">O Impacto da Anemia na Saúde Ocular</div>
						<div className="cardBlog__description">Lesões oculares relacionadas ao esporte são comuns e podem levar a perda de visão e até (...)</div>
					</div>


					<div className="card cardBlog">
						<div className="cardBlog__image"><img src={blogImage3} className="noSelect" /></div>
						<div className="cardBlog__category"><span>Na Mídia</span></div>
						<div className="cardBlog__title">Os Desafios Visuais do Albinismo</div>
						<div className="cardBlog__description">Lesões oculares relacionadas ao esporte são comuns e podem levar a perda de visão e até (...)</div>
					</div>


					<div className="card cardBlog">
						<div className="cardBlog__image"><img src={blogImage4} className="noSelect" /></div>
						<div className="cardBlog__category"><span>Na Mídia</span></div>
						<div className="cardBlog__title">Mês de Conscientização sobre o Autismo</div>
						<div className="cardBlog__description">Lesões oculares relacionadas ao esporte são comuns e podem levar a perda de visão e até (...)</div>
					</div>				*/}											


				</div>		

				<div className="wrapper_home__content_container_cta" style={{marginTop:"2.5rem",marginBottom:"7.31rem"}}><Button label="Veja mais em nosso blog" rounded className="pT10 headerButtonRight filled" style={{marginTop:"0.5rem"}} onClick={()=>navigate("/noticias")}  /></div>

			</div>	
		
		</div>


	</div>

		<ForgotPasswordView
			forgotPassword={forgotPassword}
			setForgotPassword={setForgotPassword}
			scrollBlock={false}		
			setAlert={setAlert}
			setAlertTitle={setAlertTitle}
			setAlertBody={setAlertBody}					
		/>			

	  <AlertView
		alert={alert}
		setAlert={setAlert}
		alertTitle={alertTitle}
		alertBody={alertBody}	
		setAlertAction={setAlertAction}
		scrollBlock={false}			
	  />

	</>
  );
	
}

const mapStateToProps = store => ({
  dialog:store.appReducer.dialog,
  loginStatus:store.appReducer.loginStatus,
  currentCompanyStatus:store.appReducer.currentCompanyStatus,
  currentPartner:store.appReducer.currentPartner
 });
const mapDispatchToProps = dispatch => bindActionCreators({ ...AppActions, ...LoginActions }, dispatch);

export default connect(
		mapStateToProps,
		mapDispatchToProps
	)(HomePage);	
